import { Axios } from "api/axios";

const toTitleCase = (value?: string): string =>
  (value || "")
    .toLowerCase()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export interface GeoNamesPostalCode {
  postalCode: string;
  placeName: string;
  countryCode: string;
  adminName1: string; // State
  adminCode1: string;
}

/**
 * Fetches geographic details for a postal/pincode from our local backend Pincode Master database.
 * @param pincode The postal/pin code to search
 * @param countryCode Optional country code filter (not needed for local lookup but kept for signature compatibility)
 */
export const fetchAddressFromPincode = async (
  pincode: string,
  countryCode?: string
): Promise<GeoNamesPostalCode | null> => {
  try {
    const response = await Axios.get(`/masters/pincode/${pincode}`);
    const result = response.data;
    if (result && result.success && result.data) {
      const pinData = result.data;
      
      // Determine standard country code based on DB country name
      let resolvedCountryCode = "IN";
      if (pinData.country?.toLowerCase() === "india") {
        resolvedCountryCode = "IN";
      } else if (pinData.country?.toLowerCase() === "united states" || pinData.country?.toLowerCase() === "us") {
        resolvedCountryCode = "US";
      }

      return {
        postalCode: pinData.pincode,
        placeName: toTitleCase(pinData.city),
        countryCode: resolvedCountryCode,
        adminName1: toTitleCase(pinData.state),
        adminCode1: "",
      };
    }
  } catch (error: any) {
    console.error("Local pincode master lookup failed:", error?.response?.data?.message || error.message);
  }
  return null;
};
